import React from 'react';
import { CrunchbaseIcon } from '../components/icons/CrunchbaseIcon';
import { MediumIcon } from '../components/icons/MediumIcon';
import { SubstackIcon } from '../components/icons/SubstackIcon';

export interface FounderLink {
  id: string;
  label: string;
  href: string;
  icon: React.FC<{ size?: number; className?: string }>;
}

export const founderLinks: FounderLink[] = [
  {
    id: 'crunchbase',
    label: 'Crunchbase',
    href: 'https://www.crunchbase.com/person/ruhlan-jafarli',
    icon: CrunchbaseIcon
  },
  {
    id: 'medium',
    label: 'Medium',
    href: 'https://helenendorfsky.medium.com/',
    icon: MediumIcon
  },
  {
    id: 'substack',
    label: 'Substack',
    href: 'https://substack.com/@helenendorfsky',
    icon: SubstackIcon
  }
];
